import { Stack } from '@ltvco/refresh-lib/theme';

import { CLASS_ACTION_REPORT_SECTION_IDS } from '../shared/constants';
import { DesktopReportSection } from '../shared/DesktopReportSection';

import { RelatedCaseMiniCard } from './RelatedCaseMiniCard';

import type { DocketDetailRelatedCasesSection } from '../types';

export function RelatedCasesSection({
  related_cases,
}: {
  related_cases: DocketDetailRelatedCasesSection;
}) {
  if (!related_cases.items?.length) {
    return null;
  }

  return (
    <DesktopReportSection
      title="Related Cases"
      sectionId={CLASS_ACTION_REPORT_SECTION_IDS.related_cases}
    >
      <Stack spacing={2}>
        {related_cases.items.map((item, idx) => (
          <RelatedCaseMiniCard key={`${item.case_title}-${idx}`} item={item} />
        ))}
      </Stack>
    </DesktopReportSection>
  );
}
